import { render } from "./FooterComponent.vue?vue&type=template&id=2d75434c&scoped=true"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=2d75434c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krili\\Projects\\krilin_website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d75434c"]])

export default __exports__